import { createIcon } from "@chakra-ui/react";

// Source: https://fontawesome.com/icons/cloud-hail?s=solid
export default createIcon({
  displayName: "CloudHail",
  viewBox: "0 0 512 512",
  path: (
    <path
      d="M416 128c-.625 0-1.125 .25-1.625 .25C415.5 123 416 117.6 416 112C416 67.75 380.2 32 336 32c-24.62 0-46.25 11.25-61 28.75C256.4 24.75 219.2 0 176 0C114.1 0 64 50.12 64 112c0 7.25 .75 14.25 2.125 21.25C27.75 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96S469 128 416 128zM384 352c-17.75 0-32 14.25-32 32s14.25 32 32 32s32-14.25 32-32S401.8 352 384 352zM192 448c-17.75 0-32 14.25-32 32s14.25 32 32 32s32-14.25 32-32S209.8 448 192 448zM320 448c-17.75 0-32 14.25-32 32s14.25 32 32 32s32-14.25 32-32S337.8 448 320 448zM256 352c-17.75 0-32 14.25-32 32s14.25 32 32 32s32-14.25 32-32S273.8 352 256 352zM64 448c-17.75 0-32 14.25-32 32s14.25 32 32 32s32-14.25 32-32S81.75 448 64 448zM128 352c-17.75 0-32 14.25-32 32s14.25 32 32 32s32-14.25 32-32S145.8 352 128 352z"
      fill="currentColor"
    />
  ),
});
